(() => {
  'use strict';
  const setup = () => {
    document.querySelectorAll('[id^="conversion-"][type="application/json"]').forEach(node => {
      const config = JSON.parse(node.textContent);
      const root = document.getElementById('product-id-' + config.section);
      const form = root?.querySelector('form[data-product-form]');
      if (!form || root.dataset.conversionReady) return;
      root.dataset.conversionReady = 'true';
      const t = config.texts;
      const visible = el => el.getClientRects().length && !el.disabled && el.type !== 'hidden';
      const quantity = form.querySelector('input[name="quantity"]');
      const priceTemplate = document.getElementById('conversion-price-' + config.section);
      const offers = form.querySelector('.offers');
      if (priceTemplate && offers) {
        const content = priceTemplate.content.cloneNode(true);
        const label = content.querySelector('[data-conversion-price-label]');
        offers.prepend(label);
        if(config.handle==='fonsterbleck')offers.dataset.conversionPending='true';
        offers.after(content);
      }
      if (quantity) {
        quantity.step = '1';
        quantity.inputMode = 'numeric';
        quantity.setAttribute('aria-label', t.quantity);
        const help = document.createElement('small');
        help.id = 'conversion-quantity-' + config.section;
        help.className = 'conversion-quantity-help';
        help.textContent = t.quantity_help;
        quantity.closest('span.quantity')?.after(help);
        quantity.setAttribute('aria-describedby', help.id);
      }
      const seen = new WeakSet();
      const touched = new Set();
      form.addEventListener('input', event => { if(event.target.name) touched.add(event.target.name); }, true);
      const errors = new WeakMap();
      let attempted = false;
      const priceError = document.createElement('p');
      priceError.className = 'conversion-field-error';
      priceError.hidden = true;
      priceError.setAttribute('role', 'alert');
      if (priceTemplate) form.querySelector('.purchase-section')?.prepend(priceError);
      const labelFor = input => input.getAttribute('aria-label') || input.closest('.cl-po--option')?.querySelector('.cl-po--label')?.textContent.trim() || input.name;
      const rangeFor = input => {
        if (!input.min || !input.max) return '';
        return t.range.replace('{min}', input.min).replace('{max}', input.max).replace('{unit}', labelFor(input).includes('°') ? '°' : 'mm');
      };
      const inputs = () => Array.from(form.querySelectorAll('input.cl-po--input, select.cl-po--input, textarea.cl-po--input')).filter(visible);
      const enhance = () => {
        inputs().forEach(input => {
          if (!touched.has(input.name) && input.type === 'number' && input.required && Number(input.min) > 0 && input.value === '0') {
            input.value = '';
          }
          if (seen.has(input)) return;
          seen.add(input);
          input.inputMode = 'decimal';
          const option = input.closest('.cl-po--option');
          if (!option) return;
          const hint = document.createElement('p');
          hint.className = 'conversion-field-help';
          hint.id = input.id + '-conversion-help';
          const length = config.handle === 'fonsterbleck' && input.name === 'properties[_custom_length_x]';
          if (length) {
            input.setAttribute('aria-label', t.length);
            const label = option.querySelector('.cl-po--label');
            if (label) label.textContent = t.length;
            hint.textContent = t.length_help;
          } else hint.textContent = rangeFor(input);
          if (hint.textContent) { input.after(hint); input.setAttribute('aria-describedby', [input.getAttribute('aria-describedby'), hint.id].filter(Boolean).join(' ')); }
          const error = document.createElement('p');
          error.id = input.id + '-conversion-error';
          error.className = 'conversion-field-error';
          error.setAttribute('aria-live', 'polite');
          error.hidden = true;
          option.append(error);
          errors.set(input, error);
          input.setAttribute('aria-describedby', [input.getAttribute('aria-describedby'), error.id].filter(Boolean).join(' '));
        });
        if (config.handle === 'fonsterbleck' && !form.querySelector('.conversion-measure-intro')) {
          const option = form.querySelector('.cl-po--wrapper');
          if (option) { const intro = document.createElement('p'); intro.className = 'conversion-measure-intro'; intro.textContent = t.measure_help; option.prepend(intro); }
        }
      };
      const validate = show => {
        let first = null;
        inputs().forEach(input => {
          // Length is a text input in the app; validate its documented range explicitly.
          if(config.handle === 'fonsterbleck' && input.name === 'properties[_custom_length_x]'){
            const length=Number(input.value.trim().replace(',', '.'));
            input.setCustomValidity(input.value.trim() && (!Number.isFinite(length)||length<=0||length>1980) ? t.length_error : '');
          }
          const valid = input.validity.valid && (!input.required || input.value.trim() !== '');
          const error = errors.get(input);
          if (!valid && !first) first = input;
          if (error) {
            error.hidden = valid || !show;
            const message = input.validationMessage === t.length_error ? t.length_error : input.value.trim() === '' ? t.required.replace('{label}', labelFor(input)) : t.invalid.replace('{label}', labelFor(input)).replace('{range}', rangeFor(input));
            if (error.textContent !== message) error.textContent = message;
          }
          input.setAttribute('aria-invalid', String(!valid && show));
        });
        if (quantity && visible(quantity)) {
          const valid = Number.isInteger(Number(quantity.value)) && Number(quantity.value) >= 1;
          quantity.setCustomValidity(valid ? '' : t.quantity_error);
          quantity.setAttribute('aria-invalid', String(!valid && show));
          const help = document.getElementById('conversion-quantity-' + config.section);
          if(help) { help.textContent = !valid && show ? t.quantity_error : t.quantity_help; help.classList.toggle('conversion-field-error', !valid && show); }
          if (!quantity.validity.valid && !first) first = quantity;
        }
        return first;
      };
      const guard = event => {
        if (event.type === 'click' && !event.target.closest('button[name="add"],.add-to-cart')) return;
        attempted = true;
        enhance();
        const first = validate(true);
        if (first) { event.preventDefault(); event.stopImmediatePropagation(); first.focus(); first.scrollIntoView({behavior: 'smooth', block: 'center'}); }
        else if(priceTemplate && (config.handle === 'fonsterbleck' || form.querySelector('.cl-po--wrapper')) && (!form.querySelector('.cl-po--wrapper') || !form.querySelector('.pd-other-summary')?.dataset.configuredPrice)) {
          event.preventDefault(); event.stopImmediatePropagation();
          priceError.textContent = t.price_unavailable;
          priceError.hidden = false;
          priceError.scrollIntoView({behavior:'smooth', block:'center'});
        }
      };
      form.addEventListener('click', guard, true);
      form.addEventListener('submit', guard, true);
      form.addEventListener('input', () => validate(attempted));
      form.addEventListener('change', () => validate(attempted));
      window.addEventListener('options:rendered', enhance);
      window.addEventListener('options:price', () => { priceError.hidden = true; });
      const observer = new MutationObserver(records => { if (records.some(r => r.addedNodes.length)) enhance(); });
      observer.observe(form, {childList: true, subtree: true});
      enhance();
      const accessories = document.getElementById('conversion-accessories-' + config.section);
      if (accessories) {
        const panel = accessories.content.firstElementChild.cloneNode(true);
        const purchase = form.querySelector('.purchase-section');
        if (purchase) purchase.after(panel);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once: true}); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
